import { useQuery } from "@tanstack/react-query";
import { getProfile } from "@/lib/api/generated";

/**
 * Where the profile is being opened from. The backend records the view with
 * both ids, so a view made from a search is attributed to that search and
 * its project (and can be hidden by "hide viewed" scoped to either).
 */
export interface ProfileViewContext {
  searchId?: string | null;
  projectId?: string | null;
}

export function profileDetailQueryKey(
  profileId: string,
  context?: ProfileViewContext,
) {
  return [
    "profile",
    profileId,
    context?.searchId ?? null,
    context?.projectId ?? null,
  ] as const;
}

export function getProfileWithContext(
  profileId: string,
  context?: ProfileViewContext,
) {
  return getProfile(profileId, {
    ...(context?.searchId ? { search_id: context.searchId } : {}),
    ...(context?.projectId ? { project_id: context.projectId } : {}),
  });
}

export function useProfileDetail(
  profileId: string | null,
  context?: ProfileViewContext,
) {
  return useQuery({
    queryKey: profileDetailQueryKey(profileId!, context),
    queryFn: () => getProfileWithContext(profileId!, context),
    enabled: !!profileId,
  });
}
